module.exports = __webpack_public_path__ + "img/crosshairs-solid.2a300115.svg";